import React from 'react';

interface BackNumberProps {
    /** The number to display inside the icon (e.g. seconds to skip) */
    number: number | string;
    /** Optional class applied to the `<svg>` for styling */
    className?: string;
}

const BackNumber: React.FC<BackNumberProps> = ({ number, className }) => (
    <svg
        className={className}
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {/* Circle + backward arrow */}
        <path
            d="M15.1667 4.87484L13 2.1665C18.9833 2.1665 23.8334 7.01659 23.8334 12.9998C23.8334 18.9831 18.9833 23.8332 13 23.8332C7.01677 23.8332 2.16669 18.9831 2.16669 12.9998C2.16669 8.55817 4.84035 4.73942 8.66669 3.06784"
            stroke="currentColor"
            strokeWidth="1.625"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity="0.5"
        />
        {/* The number label */}
        <text
            x="13"
            y="13"
            textAnchor="middle"
            dominantBaseline="middle"
            fill="currentColor"
            fontSize="10"
            fontWeight="1000"
        >
            {number}
        </text>
    </svg>
);

export default BackNumber;
